import { Injectable } from '@angular/core';
declare let THREE: any;
import { StageService } from './stage.service';
import {ObjectCheckerService} from './object-checker.service';
import { WallHolesService } from './wall/wall-holes.service';
import { ConstantsService } from './constants.service';

@Injectable()
export class UndoService {

  undoStack = [];

  constructor(protected stage?: StageService, protected objectCheckerSrvc?: ObjectCheckerService,
  protected wallHoles?: WallHolesService, protected constants?: ConstantsService) { }

  getEntityObjects() {
    return this.stage.getChildren().filter(function (obj) {
        return obj.visible &&
            obj.userData.entity &&
            !this.objectCheckerSrvc.isFloor(obj) &&
            !this.objectCheckerSrvc.isWall(obj)
    });
}

restoreObjectPosition(obj, position) {

    obj.position.copy(position);

    if (this.objectCheckerSrvc.isWallEmbeddable(obj))
        this.wallHoles.update(obj.userData.wall);
}

  push(actionType, data?) {

    switch (actionType) {
      case 'move': {
        if (this.undoStack.length >= this.constants.UNDO_STACK_LIMIT)
          this.undoStack.pop();

        const allSceneObjects = this.getEntityObjects(),
          lastPosition = new THREE.Vector3();

        this.undoStack.unshift({
          type: 'move',
          data: allSceneObjects
            .map(function (obj) {
              lastPosition.copy(obj.position);
              return {
                uuid: obj.uuid,
                position: new THREE.Vector3().copy(obj.position)

              }
            })
        });
      } break;
      case 'delete': {
        const container = data;
        this.undoStack.unshift({
          type: 'delete',
          data: container
        });

      } break;
      case 'colorChange': {
        this.undoStack.unshift({
          type: 'colorChange',
          data: data
        });
      }
    }
  }

  pop() {

    if (this.undoStack.length === 0)
      return false;

    switch (this.undoStack[0].type) {
      case 'move': {
        const allSceneObjects = this.getEntityObjects();
        let i = 0,
          j = 0,
          sceneObj,
          undoItem;

        for (; i < allSceneObjects.length; i++) {
          sceneObj = allSceneObjects[i];
          for (j = 0; j < this.undoStack[0].data.length; j++) {
            undoItem = this.undoStack[0].data[j];
            if (sceneObj.uuid === undoItem.uuid) {
              this.restoreObjectPosition(sceneObj, undoItem.position);
              break;
            }
          }
        }
      } break;
      case 'delete': {
        this.stage.add(this.undoStack[0].data);
      } break;
      case 'colorChange': {
        // refactor
        // $rootScope.$broadcast('onColorSchemeChange', undoStack[0].data);
      }
    }

    this.undoStack.shift();

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/undo.service.ts